<template>
  <BaseProofOrOrderItemListItem
    analytics-name="Proof"
    :salesforce-id="proof.id"
    :short-title="proof.name"
    :item-code="proof.code"
    :overall-status="overallStatus"
    :proof-id="proof.proofId"
    :is-add-on="!isMain(proof)"
    :add-ons="addOns"
    :proof="proof"
    :base-proof="baseProof"
  >
    <Tooltip bottom analytics-name="Proof date">
      <template #default="{ attrs, on }">
        <span v-bind="attrs" class="text--darken-1 grey--text" v-on="on">
          {{ formatDateDistanceToNowIfRecent(proof.lastModifiedDate) }}
        </span>
      </template>
      <template #tooltip>
        <div>Created {{ formatDateVerbose(proof.createdDate) }}</div>
        <div>Updated {{ formatDateVerbose(proof.lastModifiedDate) }}</div>
      </template>
    </Tooltip>
  </BaseProofOrOrderItemListItem>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import BaseProofOrOrderItemListItem from '@/components/BaseProofOrOrderItemListItem.vue'
import {
  formatDateDistanceToNowIfRecent,
  formatDateVerbose
} from '@/components/mixins/dateFormatters'
import { isMain, proofOverallStatus } from '@/components/mixins/proofUtils'
import Tooltip from '@/components/Tooltip.vue'

import { Proof } from '../generated'

export default defineComponent({
  components: {
    BaseProofOrOrderItemListItem,
    Tooltip
  },
  props: {
    proof: {
      type: Object as PropType<Proof>,
      required: true
    },
    baseProof: {
      type: Object as PropType<Proof | null>,
      default: null
    },
    addOns: {
      type: Array as PropType<Proof[]>,
      default: () => []
    }
  },
  setup({ baseProof, proof }) {
    const overallStatus = proofOverallStatus(baseProof || proof)
    return {
      isMain,
      overallStatus,
      formatDateVerbose,
      formatDateDistanceToNowIfRecent
    }
  }
})
</script>
